<template>
  <div>
    <a-pagination
      size="small"
      show-size-changer
      show-quick-jumper
      :current="currentPage"
      :pageSize="currentPageSize"
      :total="currentTotal"
      :pageSizeOptions="pageSizeOptions"
      @change="handleChangePage"
      @showSizeChange="handleShowSizeChange"
      :show-total="total => `总共 ${total} 个记录`"
      class="tar"
    />
  </div>
</template>
<script>
import { defineComponent, inject, computed } from 'vue'
export default defineComponent({
  props: {
    // 添加 props 来接收传入的值
    pageNum: {
      type: Number
    },
    pageSize: {
      type: Number
    },
    total: {
      type: Number
    },
    changePage: {
      type: Function
    },
    onShowSizeChange: {
      type: Function
    }
  },
  setup(props) {
    // 优先使用传入的 props，如果没有则使用注入的 state
    const injectedState = inject('state', null)

    // 使用 computed 实现优先级逻辑
    const currentPage = computed(() =>
      props.pageNum ? props.pageNum : injectedState?.pageNum || 1
    )

    const currentPageSize = computed(() =>
      props.pageSize ? props.pageSize : injectedState?.pageSize || 10
    )

    const currentTotal = computed(() =>
      props.total ? props.total : injectedState?.total || 0
    )

    const handleChangePage = pageNum => {
      console.log('handleChangePage', pageNum)
      if (
        props.changePage !== (() => {}) &&
        typeof props.changePage === 'function'
      ) {
        props.changePage(pageNum)
      } else if (injectedState?.changePage) {
        injectedState.changePage(pageNum)
      }
    }

    const handleShowSizeChange = (current, pageSize) => {
      if (
        props.onShowSizeChange !== (() => {}) &&
        typeof props.onShowSizeChange === 'function'
      ) {
        props.onShowSizeChange(current, pageSize)
      } else if (injectedState?.onShowSizeChange) {
        injectedState.onShowSizeChange(current, pageSize)
      }
    }

    return {
      pageSizeOptions: ['10', '20', '50', '100', '200'],
      currentPage,
      currentPageSize,
      currentTotal,
      handleChangePage,
      handleShowSizeChange
    }
  }
})
</script>
